// extracted by mini-css-extract-plugin
module.exports = {"container":"Gj-z","copy":"Hj-z","field":"Ij-z","error":"Jj-z","disabled":"Kj-z","termsContainer":"Lj-z","termsHeading":"Mj-z","termsCopy":"Nj-z","submit":"Oj-z","srOnly":"Pj-z"};